import { programRequestsApi } from '../api/programRequestsApi';
import { toCreateConsolidateRequest } from './consolidateProgramsModel';

export const createConsolidateProgramsFlow = async ({
    form,
    onError,
    api = programRequestsApi,
}) => Boolean(
    await api.createConsolidateRequest(toCreateConsolidateRequest(form), onError)
);
